<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="800">
    <v-card>
      <!-- <ODialogBar title="Histórico de Configuração" @close="dismiss" /> -->
      <RecordDetailsDialog ref="detailsDialog" />

      <GenericReport
        ref="report"
        orientation="horizontal"
        hide-header
        class="clean-list"
        :reportSpec="reportSpec"
        :adapterSpec="adapterSpec"
        :fetcher="fetchData"
        @rowClicked="selectRow"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Paperman } from '../../../models'
import { brDateTime } from 'oderon-commons/src/formatters'
import { preProcessSpec } from 'oderon-commons/src/tables'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import RecordDetailsDialog from '../../tools/paperman/RecordDetailsDialog.vue'

const defCodes = ['id', 'timestamp', 'login', 'comments']

const adapterSpec = preProcessSpec({
  defaultSortable: false,
  defCodes,
  columns: [
    { t: 'ID|', d: '_id', selectable: true },
    {
      w: 200,
      t: 'Timestamp|',
      d: 'timestamp',
      f: brDateTime
    },
    { w: 200, t: '|Login', d: 'login' },
    { t: 'Comentários', d: 'comments', selectable: true }
  ]
})

export default {
  components: {
    GenericReport,
    RecordDetailsDialog
  },
  data() {
    return {
      reportSpec: { title: 'Histórico de Configuração' },
      adapterSpec,
      defCodes
    }
  },
  methods: {
    open(vehicleId) {
      this.vehicleId = vehicleId
      return this.$refs.dialog.$open()
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    async fetchData(apiParams) {
      const { rows, count } = await Paperman.findAndCount({
        subjectType: 'vehicle',
        id: this.vehicleId,
        action: 'updateConfigs',
        ...apiParams // limit e offset
      })

      return { rows, count }
    },

    selectRow({ row }) {
      this.$refs.detailsDialog.open(row.id)
    }
  }
}
</script>

<style></style>
